import React from "react";
import history from "../../utils/history";
import Ram1 from "../../assets/images/ram-1.webp";
import Ram2 from "../../assets/images/ram-2.webp";
import Ram3 from "../../assets/images/ram-3.webp";
const Ramtin = () => {
  return (
    <div className="prac-profile">
      <div className="profile-image"></div>
      <div className="content">
        <h2 className="name">Ramtin Dehkhoda</h2>
        <h5 className="post">LAc MSTOM</h5>
        <button
          className="btn-consult"
          // onClick={() =>
          //   window.open(
          //     "https://sdhma.janeapp.com/locations/my-herbal-pharmacy/book#/staff_member/11/treatment/544",
          //     "_self"
          //   )
          // }
          onClick={() =>
            history.push("/appointment", {
              id: "2127",
              name: "Ramtin Dehkhoda, LAc MSTOM",
            })
          }
        >
          Request a consultation
        </button>

        <p>About “Ram”</p>
        <p>
          Ramtin is an accomplished primary care practitioner renowned for his
          expertise in traditional Chinese medicine through his establishment of
          San Diego Herbal Medicine and Acupuncture. His comprehensive approach
          spans various medical realms, from specializing in internal medicine
          such as digestive health, autoimmune disorders, psycho emotional
          wellness, fertility, post viral conditions, sleep and memory to
          orthopedic conditions and sports performance.
        </p>
        <p>
          <span>Founder of San Diego Herbal Medicine & Acupuncture:</span>{" "}
          Ramtin started SDHMA in 2013, currently his clinic is a top rated
          clinic serving the greater San Diego area. The SDHMA clinic has 10
          acupuncturists, a physical therapist and a full herbal pharmacy.
        </p>
        <p>
          <span>Herbal Medicine and Software Innovation:</span> With a profound
          passion for herbal medicine he founded Myherbpharm, a groundbreaking
          herbal software company aiding acupuncturists, clinics, students and
          universities in teaching herbal medicine. He has received prestigious
          academic awards and has earned recognition in various media outlets
          for his contributions.
        </p>
        <div className="gallery-container">
          <img src={Ram1} alt="ram-image-1" className="gallery-image" />
          <img src={Ram2} alt="ram-image-2" className="gallery-image" />
          <img src={Ram3} alt="ram-image-3" className="gallery-image" />
        </div>
      </div>
    </div>
  );
};
export default Ramtin;
